<mat-menu class="mat-menu-drop-down" #childMenu="matMenu" [overlapTrigger]="false">
  <ng-container *ngFor="let child of items">
    <!-- Handle branch node menu items -->
    <ng-container *ngIf="child.children && child.children.length > 0 && this.utilService.checkRoleAccess(child)">
      <button mat-menu-item [matMenuTriggerFor]="menu.childMenu" [ngClass]="{'active' : (currentPath==child.link)}">
        <span>{{child.label}}</span>
      </button>
      <app-menu-item #menu [items]="child.children" [currentPath]="currentPath"></app-menu-item>
    </ng-container>
    <!-- Handle leaf node menu items -->
    <ng-container *ngIf="(!child.children || child.children.length === 0) && this.utilService.checkRoleAccess(child)">
      <button mat-menu-item [routerLink]="child.link" [ngClass]="{'active' : (currentPath==child.link)}">
        <span>{{child.label}}</span>
      </button>
    </ng-container>
  </ng-container>
</mat-menu>
